import { useLocationContext } from '~/contexts/location.context';
import { useGetMemberProfileQuery } from '~/services/member';

type UsePayrixCustomerId = {
  memberId: number | undefined;
};

export default function usePayrixCustomerId({ memberId }: UsePayrixCustomerId) {
  const { locationId } = useLocationContext();

  const { data: memberProfile } = useGetMemberProfileQuery({ locationId, memberId });

  const customerId = memberProfile?.payrix_customer_id;

  return { customerId, isPending: false };
}
